import React, { useEffect, useState, useRef } from "react";
import classes from './AssetAssignment.module.css';
import HeaderNav from '../../Components/Dahboard Header/HeaderNav/HeaderNav';
import Footer from "../../Components/Footer/Footer";
import { useLocation, useNavigate } from 'react-router-dom';
import { Eye, Pencil, Trash2, X, FileText, User, Calendar, FileText as Notes } from 'lucide-react';
import searchicon from "../../Assets/searchicon.png";
import filter from "../../Assets/filter.png";
import axios from "axios";
import { BASE_URL } from "../../Components/API/Api";
import Swal from 'sweetalert2';

const AssetAssignment = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const [isActive, setIsActive] = useState(false);
    const [selectedMetrics, setSelectedMetrics] = useState({
        total_assignments: 0,
        active_assignments: 0,
        returned_assets: 0,
    });

    const [loading, setLoading] = useState(true);
    const [modalLoading, setModalLoading] = useState(false);
    const [saveLoading, setSaveLoading] = useState(false);
    const [assetAssignments, setAssetAssignments] = useState([]);
    const [companyId, setCompanyId] = useState(null);

    // Modal state
    const [showCreateModal, setShowCreateModal] = useState(false);
    const [showViewEditModal, setShowViewEditModal] = useState(false);
    const [modalMode, setModalMode] = useState("view");
    const [selectedAssignment, setSelectedAssignment] = useState(null);

    // Create Modal state
    const [assets, setAssets] = useState([]);
    const [employees, setEmployees] = useState([]);
    const [createFormData, setCreateFormData] = useState({
        asset_id: "",
        employee_id: "",
        assigned_date: "",
        returned_date: "",
        condition_notes: "",
        company_id: ""
    });
    const [createLoading, setCreateLoading] = useState({
        assets: false,
        employees: false
    });
    const [submitting, setSubmitting] = useState(false);

    // For searchable selects in create modal
    const [searchTerms, setSearchTerms] = useState({
        asset: "",
        employee: ""
    });
    const [showDropdowns, setShowDropdowns] = useState({
        asset: false,
        employee: false
    });
    
    // Create refs for each dropdown
    const assetRef = useRef(null);
    const employeeRef = useRef(null);

    // Modal form data for view/edit
    const [modalData, setModalData] = useState({
        id: "",
        asset_id: "",
        asset_name: "",
        asset_code: "",
        employee_id: "",
        employee_name: "",
        employee_code: "",
        assigned_date: "",
        returned_date: "",
        condition_notes: "",
        status: "",
        company_id: ""
    });

    // Get company ID from localStorage - FIXED VERSION
    useEffect(() => {
        const getCompanyId = () => {
            console.log("Attempting to get company ID from various sources...");
            
            // First check if we have a company_id directly in localStorage (set by Login component)
            const directCompanyId = localStorage.getItem("company_id");
            if (directCompanyId) {
                console.log("Found company_id in localStorage:", directCompanyId);
                setCompanyId(directCompanyId);
                setCreateFormData(prev => ({
                    ...prev,
                    company_id: directCompanyId
                }));
                return;
            }
            
            // Check for companyInfo
            const companyInfo = localStorage.getItem("companyInfo");
            if (companyInfo) {
                try {
                    const parsed = JSON.parse(companyInfo);
                    console.log("Found companyInfo:", parsed);
                    
                    // Try to get ID from various possible fields
                    const id = parsed?.id || parsed?.company_id || parsed?.companyId;
                    if (id) {
                        setCompanyId(String(id));
                        setCreateFormData(prev => ({
                            ...prev,
                            company_id: String(id)
                        }));
                        console.log("Using company ID from companyInfo:", id);
                        return;
                    }
                } catch (error) {
                    console.error("Error parsing companyInfo:", error);
                }
            }
            
            // Check user data
            const userData = localStorage.getItem("user");
            if (userData) {
                try {
                    const parsed = JSON.parse(userData);
                    console.log("User data from localStorage:", parsed);
                    
                    // Check for direct company_id
                    if (parsed.company_id) {
                        setCompanyId(parsed.company_id);
                        setCreateFormData(prev => ({
                            ...prev,
                            company_id: parsed.company_id
                        }));
                        console.log("Using direct company_id from user:", parsed.company_id);
                        return;
                    }
                    
                    // Check for company object
                    if (parsed.company) {
                        const companyId = parsed.company?.id || parsed.company?.company_id || parsed.company?.companyId;
                        if (companyId) {
                            setCompanyId(String(companyId));
                            setCreateFormData(prev => ({
                                ...prev,
                                company_id: String(companyId)
                            }));
                            console.log("Using company ID from user.company:", companyId);
                            return;
                        }
                    }
                    
                    // Check for companies array
                    if (parsed.companies && Array.isArray(parsed.companies) && parsed.companies.length > 0) {
                        // Try to find main company
                        const mainCompany = parsed.companies.find(c => c.is_main === "1" || c.is_main === 1);
                        if (mainCompany) {
                            const companyId = mainCompany?.id || mainCompany?.company_id || mainCompany?.companyId;
                            if (companyId) {
                                setCompanyId(String(companyId));
                                setCreateFormData(prev => ({
                                    ...prev,
                                    company_id: String(companyId)
                                }));
                                console.log("Using main company ID from companies array:", companyId);
                                return;
                            }
                        }
                        
                        // Use first company
                        const firstCompany = parsed.companies[0];
                        if (firstCompany) {
                            const companyId = firstCompany?.id || firstCompany?.company_id || firstCompany?.companyId;
                            if (companyId) {
                                setCompanyId(String(companyId));
                                setCreateFormData(prev => ({
                                    ...prev,
                                    company_id: String(companyId)
                                }));
                                console.log("Using first company ID from companies array:", companyId);
                                return;
                            }
                        }
                    }
                } catch (error) {
                    console.error("Error parsing user data:", error);
                }
            }
            
            console.warn("No company ID found in any source");
        };
        
        getCompanyId();
    }, []);

    // Close dropdowns when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (assetRef.current && !assetRef.current.contains(event.target)) {
                setShowDropdowns(prev => ({ ...prev, asset: false }));
            }
            if (employeeRef.current && !employeeRef.current.contains(event.target)) {
                setShowDropdowns(prev => ({ ...prev, employee: false }));
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    // Fetch data for create modal when opened
    useEffect(() => {
        if (showCreateModal) {
            if (companyId) {
                fetchAssets();
                fetchEmployees();
            } else {
                console.warn("Cannot fetch assets/employees: Company ID not available");
                Swal.fire({
                    icon: 'warning',
                    title: 'Company ID Missing',
                    text: 'Please select a company and try again.',
                    confirmButtonText: 'Go to Dashboard'
                }).then(() => {
                    setShowCreateModal(false);
                    navigate('/dashboard');
                });
            }
        }
    }, [showCreateModal, companyId]);

    // Fetch asset assignments when companyId is available
    useEffect(() => {
        if (companyId) {
            console.log("Company ID available, fetching asset assignments for company:", companyId);
            fetchAssetAssignments();
        } else {
            console.warn("Company ID not available yet, waiting...");
        }
    }, [companyId]);

    const fetchAssetAssignments = async () => {
        setLoading(true);
        try {
            const token = localStorage.getItem("authToken");
            
            if (!token) {
                console.error("No auth token found");
                Swal.fire({
                    icon: 'error',
                    title: 'Authentication Error',
                    text: 'Please log in again'
                });
                setLoading(false);
                return;
            }

            if (!companyId) {
                console.error("Company ID is required");
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Company ID not found. Please select a company and try again.'
                });
                setLoading(false);
                return;
            }

            console.log(`Fetching asset assignments for company ID: ${companyId}`);
            
            const response = await axios.get(`${BASE_URL}/v1/assetassignment`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                params: {
                    company_id: companyId
                }
            });

            console.log("Asset assignments response:", response.data);

            if (response.data.status && Array.isArray(response.data.data)) {
                setAssetAssignments(response.data.data);
                
                // Update metrics
                const activeAssignments = response.data.data.filter(ass => !ass.returned_date).length;
                const returnedAssets = response.data.data.filter(ass => ass.returned_date).length;
                
                setSelectedMetrics({
                    total_assignments: response.data.data.length,
                    active_assignments: activeAssignments,
                    returned_assets: returnedAssets
                });
                
                console.log(`Loaded ${response.data.data.length} asset assignments`);
            } else {
                console.warn("Unexpected response format:", response.data);
                setAssetAssignments([]);
            }
        } catch (error) {
            console.error("Error fetching asset assignments:", error);
            
            if (error.response) {
                console.error("Error response data:", error.response.data);
                console.error("Error response status:", error.response.status);
                
                let errorMessage = "Failed to fetch asset assignments";
                if (error.response.data && error.response.data.message) {
                    errorMessage = error.response.data.message;
                } else if (error.response.status === 401) {
                    errorMessage = "Unauthorized. Please log in again.";
                } else if (error.response.status === 404) {
                    errorMessage = "API endpoint not found";
                }
                
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: errorMessage
                });
            } else if (error.request) {
                console.error("No response received:", error.request);
                Swal.fire({
                    icon: 'error',
                    title: 'Network Error',
                    text: 'No response from server. Please check your connection.'
                });
            } else {
                console.error("Error setting up request:", error.message);
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'An error occurred while setting up the request'
                });
            }
            
            setAssetAssignments([]);
        } finally {
            setLoading(false);
        }
    };

    const fetchAssets = async () => {
        setCreateLoading(prev => ({ ...prev, assets: true }));
        try {
            const token = localStorage.getItem("authToken");
            
            if (!companyId) {
                console.error("Cannot fetch assets: No company ID");
                return;
            }
            
            // Fixed: Using the correct endpoint for fixed assets register
            const response = await axios.get(`${BASE_URL}/v1/fixedassets/fetch`, {
                headers: { Authorization: `Bearer ${token}` },
                params: { company_id: companyId }
            });
            
            console.log("Assets response:", response.data);
            
            // The API returns data in the format: { status: true, data: [...] }
            if (response.data.status && Array.isArray(response.data.data)) {
                // Filter assets that are available for assignment (not already assigned or returned)
                const availableAssets = response.data.data.filter(asset => {
                    // Check if asset is not already assigned to someone
                    return asset.status === 'available' || !asset.assigned_to;
                });
                
                setAssets(availableAssets);
                console.log(`Loaded ${availableAssets.length} available assets`);
            } else {
                console.warn("Unexpected assets response format:", response.data);
                setAssets([]);
            }
        } catch (error) {
            console.error("Error fetching assets:", error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Failed to fetch assets. Please try again.'
            });
        } finally {
            setCreateLoading(prev => ({ ...prev, assets: false }));
        }
    };

    const fetchEmployees = async () => {
        setCreateLoading(prev => ({ ...prev, employees: true }));
        try {
            const token = localStorage.getItem("authToken");
            
            if (!companyId) {
                console.error("Cannot fetch employees: No company ID");
                return;
            }
            
            const response = await axios.get(`${BASE_URL}/v1/employee/paginated`, {
                headers: { Authorization: `Bearer ${token}` },
                params: { company_id: companyId }
            });
            
            console.log("Employees response:", response.data);
            
            // Handle paginated response: { status, message, data: { current_page, data: [...], ... } }
            if (response.data.status && response.data.data?.data && Array.isArray(response.data.data.data)) {
                setEmployees(response.data.data.data);
            } else {
                console.warn("Unexpected employees response format:", response.data);
                setEmployees([]);
            }
        } catch (error) {
            console.error("Error fetching employees:", error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Failed to fetch employees. Please try again.'
            });
        } finally {
            setCreateLoading(prev => ({ ...prev, employees: false }));
        }
    };

    const pageMap = {
        '/dashboard': 'Dashboard',
        '/transactions': 'Transactions',
        '/accounts': 'Accounting',
        '/reports': 'Reports',
        '/banking': 'Banking',
        '/settings': 'Settings',
        '/fixed-assets': 'Fixed Assets',
    };

    // Process assignment data for modal
    const processAssignmentData = (assignment) => {
        console.log("Processing assignment data:", assignment);
        setModalData({
            id: assignment.id,
            asset_id: assignment.asset_id || assignment.fixedasset?.id,
            asset_name: assignment.fixedasset?.asset_name || assignment.asset_name || "N/A",
            asset_code: assignment.fixedasset?.asset_code || assignment.asset_code || "N/A",
            employee_id: assignment.employee_id || assignment.employee?.id,
            employee_name: assignment.employee?.name || assignment.employee_name || "N/A",
            employee_code: assignment.employee?.employee_code || assignment.employee_code || "N/A",
            assigned_date: assignment.assigned_date || "",
            returned_date: assignment.returned_date || "",
            condition_notes: assignment.condition_notes || "",
            status: assignment.returned_date ? "Returned" : "Active",
            company_id: assignment.company_id || ""
        });
    };

    // Handle View/Edit icon clicks
    const handleViewClick = async (assignment) => {
        setModalMode("view");
        setSelectedAssignment(assignment);
        setModalLoading(true);
        setShowViewEditModal(true);
        processAssignmentData(assignment);
        setModalLoading(false);
    };

    const handleEditClick = async (assignment) => {
        setModalMode("edit");
        setSelectedAssignment(assignment);
        setModalLoading(true);
        setShowViewEditModal(true);
        processAssignmentData(assignment);
        setModalLoading(false);
    };

    // Handle modal input changes for view/edit
    const handleModalChange = (field, value) => {
        setModalData(prev => ({
            ...prev,
            [field]: value
        }));
    };

    // Handle create form changes
    const handleCreateChange = (e) => {
        const { name, value } = e.target;
        setCreateFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    // Handle searchable select for create modal
    const handleSearchChange = (field, e) => {
        setSearchTerms(prev => ({ ...prev, [field]: e.target.value }));
        if (!showDropdowns[field]) {
            setShowDropdowns(prev => ({ ...prev, [field]: true }));
        }
    };

    const handleSelect = (field, item) => {
        setCreateFormData(prev => ({
            ...prev,
            [field === 'asset' ? 'asset_id' : 'employee_id']: item.id
        }));
        
        let displayName = '';
        if (field === 'asset') {
            displayName = `${item.asset_name} (${item.asset_code})`;
        } else {
            displayName = `${item.name} (${item.employee_code || 'No Code'})`;
        }
        
        setSearchTerms(prev => ({ ...prev, [field]: displayName }));
        setShowDropdowns(prev => ({ ...prev, [field]: false }));
    };

    const getSelectedName = (field) => {
        const idField = field === 'asset' ? 'asset_id' : 'employee_id';
        const id = createFormData[idField];
        
        if (!id) return "";
        
        let items = field === 'asset' ? assets : employees;
        const item = items.find(i => i.id === id);
        
        if (!item) return "";
        
        if (field === 'asset') {
            return `${item.asset_name} (${item.asset_code})`;
        } else {
            return `${item.name} (${item.employee_code || 'No Code'})`;
        }
    };

    const filterItems = (field) => {
        const searchTerm = (searchTerms[field] || "").toLowerCase();
        let items = field === 'asset' ? assets : employees;
        
        if (!Array.isArray(items)) {
            return [];
        }
        
        return items.filter(item => {
            if (!item) return false;
            
            if (field === 'asset') {
                const assetName = (item.asset_name || "").toLowerCase();
                const assetCode = (item.asset_code || "").toLowerCase();
                return assetName.includes(searchTerm) || assetCode.includes(searchTerm);
            } else {
                const empName = (item.name || "").toLowerCase();
                const empCode = (item.employee_code || "").toLowerCase();
                return empName.includes(searchTerm) || empCode.includes(searchTerm);
            }
        });
    };

    // FIXED: Handle save for edit mode with correct /assetassignment/edit endpoint
    const handleSave = async () => {
        if (modalMode === "edit") {
            setSaveLoading(true);
            try {
                const token = localStorage.getItem("authToken");

                // Double-check company ID
                let currentCompanyId = modalData.company_id || companyId;
                
                if (!currentCompanyId) {
                    currentCompanyId = localStorage.getItem("company_id");
                }

                if (!currentCompanyId) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Company ID Error',
                        text: 'Company ID not found. Please select a company and try again.'
                    });
                    setSaveLoading(false);
                    return;
                }

                // Create payload with id and all fields that can be updated
                const requestData = {
                    id: selectedAssignment.id,
                    asset_id: modalData.asset_id,
                    employee_id: modalData.employee_id,
                    assigned_date: modalData.assigned_date,
                    returned_date: modalData.returned_date || null,
                    condition_notes: modalData.condition_notes,
                    company_id: currentCompanyId
                };

                console.log("Updating asset assignment with data:", requestData);
                console.log("API Endpoint:", `${BASE_URL}/v1/assetassignment/edit`);

                // Use the correct /assetassignment/edit endpoint
                const response = await axios.post(
                    `${BASE_URL}/v1/assetassignment/edit`,
                    requestData,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Content-Type': 'application/json'
                        },
                    }
                );

                console.log("Update response:", response.data);

                if (response.data.status) {
                    await fetchAssetAssignments();
                    setShowViewEditModal(false);

                    Swal.fire({
                        icon: 'success',
                        title: 'Success!',
                        text: response.data.message || 'Asset assignment updated successfully!',
                        timer: 3000,
                        showConfirmButton: false
                    });
                } else {
                    let errorMessage = "Failed to update asset assignment";
                    if (response.data.message) {
                        if (typeof response.data.message === 'object') {
                            errorMessage = Object.values(response.data.message).flat().join(', ');
                        } else {
                            errorMessage = response.data.message;
                        }
                    }

                    Swal.fire({
                        icon: 'error',
                        title: 'Error!',
                        text: errorMessage
                    });
                }
            } catch (error) {
                console.error("Error updating asset assignment:", error);

                let errorMessage = "Failed to update asset assignment";

                if (error.response) {
                    console.error("Error response:", error.response.data);
                    
                    if (error.response.data && error.response.data.message) {
                        if (typeof error.response.data.message === 'object') {
                            errorMessage = Object.values(error.response.data.message).flat().join(', ');
                        } else {
                            errorMessage = error.response.data.message;
                        }
                    } else if (error.response.status === 422) {
                        errorMessage = "Validation error. Please check all required fields.";
                    } else if (error.response.status === 401) {
                        errorMessage = "Unauthorized. Please log in again.";
                    } else if (error.response.status === 404) {
                        errorMessage = "API endpoint not found. Please check the URL.";
                    }
                } else if (error.request) {
                    errorMessage = "No response from server. Please check your connection.";
                }

                Swal.fire({
                    icon: 'error',
                    title: 'Error!',
                    text: errorMessage,
                    confirmButtonText: 'OK'
                });
            } finally {
                setSaveLoading(false);
            }
        } else {
            setShowViewEditModal(false);
        }
    };

    // Handle create submit
    const handleCreateSubmit = async (e) => {
        e.preventDefault();

        if (!createFormData.asset_id || !createFormData.employee_id || !createFormData.assigned_date) {
            Swal.fire("Error", "Please fill in all required fields", "error");
            return;
        }

        // Double-check company ID
        let currentCompanyId = companyId;
        
        if (!currentCompanyId) {
            currentCompanyId = localStorage.getItem("company_id");
            
            if (!currentCompanyId) {
                const companyInfo = localStorage.getItem("companyInfo");
                if (companyInfo) {
                    try {
                        const parsed = JSON.parse(companyInfo);
                        currentCompanyId = parsed?.id || parsed?.company_id || parsed?.companyId;
                    } catch (error) {
                        console.error("Error parsing companyInfo:", error);
                    }
                }
            }
            
            if (currentCompanyId) {
                setCompanyId(currentCompanyId);
            }
        }

        if (!currentCompanyId) {
            Swal.fire({
                icon: 'error',
                title: 'Company ID Error',
                text: 'Company ID not found. Please select a company and try again.',
                confirmButtonText: 'Go to Dashboard'
            }).then(() => {
                navigate('/dashboard');
            });
            return;
        }

        try {
            setSubmitting(true);
            const token = localStorage.getItem("authToken");

            const payload = {
                asset_id: createFormData.asset_id,
                employee_id: createFormData.employee_id,
                assigned_date: createFormData.assigned_date,
                returned_date: createFormData.returned_date || null,
                condition_notes: createFormData.condition_notes || null,
                company_id: currentCompanyId
            };

            console.log("Creating asset assignment with payload:", payload);

            const response = await axios.post(
                `${BASE_URL}/v1/assetassignment/create`,
                payload,
                { headers: { Authorization: `Bearer ${token}` } }
            );

            console.log("Create response:", response.data);

            if (response.data?.status) {
                Swal.fire({
                    title: "Success",
                    text: response.data.message || "Asset assignment created successfully",
                    icon: "success",
                    timer: 1500,
                    showConfirmButton: false
                });
                
                resetCreateForm();
                onClose();
                await fetchAssetAssignments();
            } else {
                Swal.fire("Error", response.data?.message || "Failed to create asset assignment", "error");
            }
        } catch (error) {
            console.error("Error creating asset assignment:", error);
            
            let errorMessage = "Something went wrong while creating the assignment";
            if (error.response?.data?.message) {
                if (typeof error.response.data.message === 'object') {
                    errorMessage = Object.values(error.response.data.message).flat().join(', ');
                } else {
                    errorMessage = error.response.data.message;
                }
            }
            
            Swal.fire("Error", errorMessage, "error");
        } finally {
            setSubmitting(false);
        }
    };

    // FIXED: Handle delete assignment with correct /assetassignment/delete endpoint
    const handleDeleteClick = async (assignment) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'Cancel'
        });

        if (result.isConfirmed) {
            try {
                const token = localStorage.getItem("authToken");
                
                // Get current company ID
                let currentCompanyId = companyId;
                if (!currentCompanyId) {
                    currentCompanyId = localStorage.getItem("company_id");
                }
                
                if (!currentCompanyId) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Company ID Error',
                        text: 'Company ID not found. Please try again.'
                    });
                    return;
                }

                console.log(`Deleting asset assignment with ID: ${assignment.id} for company: ${currentCompanyId}`);
                
                // Use the correct /assetassignment/delete endpoint with id and company_id in the body
                const response = await axios.post(
                    `${BASE_URL}/v1/assetassignment/delete`,
                    {
                        id: assignment.id,
                        company_id: currentCompanyId
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Content-Type': 'application/json'
                        },
                    }
                );

                console.log("Delete response:", response.data);

                if (response.data.status) {
                    await fetchAssetAssignments();

                    Swal.fire({
                        icon: 'success',
                        title: 'Deleted!',
                        text: response.data.message || 'Asset assignment deleted successfully!',
                        timer: 3000,
                        showConfirmButton: false
                    });
                } else {
                    let errorMessage = response.data.message || "Failed to delete asset assignment";
                    if (typeof errorMessage === 'object') {
                        errorMessage = Object.values(errorMessage).flat().join(', ');
                    }
                    throw new Error(errorMessage);
                }
            } catch (error) {
                console.error("Error deleting asset assignment:", error);

                let errorMessage = "Failed to delete asset assignment";
                if (error.response && error.response.data && error.response.data.message) {
                    if (typeof error.response.data.message === 'object') {
                        errorMessage = Object.values(error.response.data.message).flat().join(', ');
                    } else {
                        errorMessage = error.response.data.message;
                    }
                } else if (error.message) {
                    errorMessage = error.message;
                }

                Swal.fire({
                    icon: 'error',
                    title: 'Error!',
                    text: errorMessage,
                    confirmButtonText: 'OK'
                });
            }
        }
    };

    const resetCreateForm = () => {
        setCreateFormData({
            asset_id: "",
            employee_id: "",
            assigned_date: "",
            returned_date: "",
            condition_notes: "",
            company_id: companyId
        });
        setSearchTerms({
            asset: "",
            employee: ""
        });
    };

    const onClose = () => {
        setShowCreateModal(false);
        resetCreateForm();
        setShowDropdowns({
            asset: false,
            employee: false
        });
    };

    const refreshAssignments = () => {
        fetchAssetAssignments();
    };

    // Format date
    const formatDate = (date) => {
        if (!date) return "—";
        return new Date(date).toLocaleDateString();
    };

    // Skeleton loader for table rows
    const TableSkeleton = () => {
        return Array.from({ length: 5 }).map((_, index) => (
            <tr key={index} className={classes.skeletonRow}>
                <td><div className={classes.skeletonText}></div></td>
                <td><div className={classes.skeletonText}></div></td>
                <td><div className={classes.skeletonText}></div></td>
                <td><div className={classes.skeletonText}></div></td>
                <td><div className={classes.skeletonText}></div></td>
                <td><div className={classes.skeletonText}></div></td>
                <td>
                    <div style={{ display: "flex", gap: "8px", justifyContent: "center" }}>
                        <div className={classes.skeletonIcon}></div>
                        <div className={classes.skeletonIcon}></div>
                        <div className={classes.skeletonIcon}></div>
                    </div>
                </td>
            </tr>
        ));
    };

    // Skeleton for modal form inputs
    const ModalInputSkeleton = () => (
        <div className={classes.skeletonInput}></div>
    );

    return (
        <div>
            <HeaderNav activePage={pageMap[location.pathname] || "Fixed Assets"} />

            <div className={classes.Container}>
                <div className={classes.Container}>
                    <div className={classes.actions}>
                        <button className={classes.btns} onClick={() => navigate('/transactions/sales-invoice/sale')}>
                            Sales Invoice
                        </button>
                        <button className={classes.btns} onClick={() => navigate('/Inventory/PurchaseOrder')}>
                            Purchase Order
                        </button>
                        <button className={`${classes.btns} ${isActive ? classes.active : ""}`} onClick={() => setIsActive(true)}>
                            Stock Delivery
                        </button>
                        <button onClick={() => navigate('/settings/product-services')} className={`${classes.btns} ${classes.greens}`}>
                            Product & Services
                        </button>
                    </div>

                    <header className={classes.Header}>
                        <h2 className={classes.Title}>Asset Assignments</h2>
                    </header>

                    <div className={classes.entrjj}>
                        <div className={classes.allkads}>
                            <div className={classes.thrdkad}>
                                <div className={classes.kad}>
                                    <p className={classes.kdptg}>Total Assignments</p>
                                    <p className={classes.kdptg1}>
                                        {selectedMetrics?.total_assignments?.toLocaleString() ?? '0'}
                                    </p>
                                    <div className={classes.rvnue}>
                                        <p className={classes.skaltxt}>All time assignments</p>
                                    </div>
                                </div>
                            </div>
                            <div className={classes.frtkad}>
                                <div className={classes.kad}>
                                    <p className={classes.kdptg}>Active Assignments</p>
                                    <p className={classes.kdptg2}>
                                        {selectedMetrics?.active_assignments?.toLocaleString() ?? '0'}
                                    </p>
                                    <div className={classes.rvnue}>
                                        <p className={classes.skaltxt}>Currently assigned</p>
                                    </div>
                                </div>
                            </div>
                            <div className={classes.fiftkad}>
                                <div className={classes.kad}>
                                    <p className={classes.kdptg}>Returned Assets</p>
                                    <p className={classes.kdptg3}>
                                        {selectedMetrics?.returned_assets?.toLocaleString() ?? '0'}
                                    </p>
                                    <div className={classes.rvnue}>
                                        <p className={classes.skaltxt}>Completed assignments</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className={classes.headerActions}>
                        <div className={classes.actionsRight}>
                            <div className={classes.inputWrapper}>
                                <img src={searchicon} alt="Search" className={classes.inputIconGreen} />
                                <input type="text" className={classes.searchBar} placeholder="Search assignments" />
                            </div>
                            <div className={classes.selectWrapper}>
                                <select className={classes.dropdown}>
                                    <option value="">All Status</option>
                                    <option value="active">Active</option>
                                    <option value="returned">Returned</option>
                                </select>
                                <span className={classes.dropdownArrow}>▼</span>
                            </div>
                            <div className={classes.inputWrapper}>
                                <input type="text" className={classes.searchBars} placeholder="Filter..." />
                                <img src={filter} alt="Filter" className={classes.inputIcon} />
                            </div>
                        </div>

                        <button className={classes.btnss} onClick={() => setShowCreateModal(true)}>
                            + New Assignment
                        </button>
                    </div>

                    <table className={classes.invoiceTable}>
                        <thead>
                            <tr>
                                <th>S/N</th>
                                <th>Asset</th>
                                <th>Employee</th>
                                <th>Assigned Date</th>
                                <th>Returned Date</th>
                                <th>Status</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <TableSkeleton />
                            ) : assetAssignments.length > 0 ? (
                                assetAssignments.map((assignment, index) => (
                                    <tr key={assignment.id}>
                                        <td>{index + 1}</td>
                                        <td>
                                            {assignment.fixedasset?.asset_name || "—"}
                                            {assignment.fixedasset?.asset_code && <div className={classes.smallText}>{assignment.fixedasset.asset_code}</div>}
                                        </td>
                                        <td>
                                            {assignment.employee?.name || "—"}
                                            {assignment.employee?.employee_code && <div className={classes.smallText}>{assignment.employee.employee_code}</div>}
                                        </td>
                                        <td>{formatDate(assignment.assigned_date)}</td>
                                        <td>{formatDate(assignment.returned_date)}</td>
                                        <td>
                                            <span className={!assignment.returned_date ? classes.activeStatus : classes.returnedStatus}>
                                                {!assignment.returned_date ? "Active" : "Returned"}
                                            </span>
                                        </td>
                                        <td>
                                            <div style={{ display: "flex", gap: "8px", justifyContent: "center" }}>
                                                <Eye
                                                    size={16}
                                                    style={{ cursor: "pointer", color: "#007bff" }}
                                                    onClick={() => handleViewClick(assignment)}
                                                />
                                                <Pencil
                                                    size={16}
                                                    style={{ cursor: "pointer", color: "#28a745" }}
                                                    onClick={() => handleEditClick(assignment)}
                                                />
                                                <Trash2
                                                    size={16}
                                                    style={{ cursor: "pointer", color: "#dc3545" }}
                                                    onClick={() => handleDeleteClick(assignment)}
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="7" style={{ textAlign: "center", padding: "20px" }}>
                                        {loading ? "Loading..." : "No asset assignments found"}
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* View/Edit Modal */}
            {showViewEditModal && (
                <div className={classes.overlay}>
                    <div className={classes.modal}>
                        <div className={classes.header}>
                            <div className={classes.title}>
                                <FileText className={classes.icon} />
                                <h2>{modalMode === "edit" ? "Edit Asset Assignment" : "View Asset Assignment"}</h2>
                            </div>
                            <button className={classes.closeBtn} onClick={() => setShowViewEditModal(false)} disabled={saveLoading}>
                                <X size={18} />
                            </button>
                        </div>

                        <div className={classes.formGrid}>
                            {modalLoading ? (
                                Array.from({ length: 5 }).map((_, index) => (
                                    <div className={classes.formGroup} key={index}>
                                        <div className={classes.skeletonLabel}></div>
                                        <ModalInputSkeleton />
                                    </div>
                                ))
                            ) : (
                                <>
                                    <div className={classes.formGroup}>
                                        <label>Asset</label>
                                        <input
                                            type="text"
                                            value={`${modalData.asset_name} (${modalData.asset_code})`}
                                            readOnly
                                            className={classes.Field2}
                                        />
                                    </div>

                                    <div className={classes.formGroup}>
                                        <label>Employee</label>
                                        <input
                                            type="text"
                                            value={`${modalData.employee_name} (${modalData.employee_code})`}
                                            readOnly
                                            className={classes.Field2}
                                        />
                                    </div>

                                    <div className={classes.formGroup}>
                                        <label>Assigned Date</label>
                                        <input
                                            type={modalMode === "edit" ? "date" : "text"}
                                            value={modalData.assigned_date}
                                            readOnly={modalMode === "view" || saveLoading}
                                            onChange={(e) => handleModalChange("assigned_date", e.target.value)}
                                            className={modalMode === "edit" ? classes.Field2 : classes.Field2}
                                            required
                                        />
                                    </div>

                                    <div className={classes.formGroup}>
                                        <label>Returned Date</label>
                                        <input
                                            type={modalMode === "edit" ? "date" : "text"}
                                            value={modalData.returned_date}
                                            readOnly={modalMode === "view" || saveLoading}
                                            onChange={(e) => handleModalChange("returned_date", e.target.value)}
                                            className={modalMode === "edit" ? classes.Field2 : classes.Field2}
                                            min={modalData.assigned_date}
                                        />
                                    </div>

                                    <div className={classes.formGroupFull}>
                                        <label>Condition Notes</label>
                                        <textarea
                                            value={modalData.condition_notes}
                                            readOnly={modalMode === "view" || saveLoading}
                                            onChange={(e) => handleModalChange("condition_notes", e.target.value)}
                                            className={modalMode === "edit" ? classes.textarea2 : classes.textarea2}
                                            rows="3"
                                            placeholder="Enter condition notes or remarks..."
                                        />
                                    </div>

                                    <input type="hidden" value={modalData.company_id} />
                                </>
                            )}
                        </div>

                        <button
                            className={classes.saveBtn}
                            onClick={handleSave}
                            disabled={saveLoading}
                        >
                            {saveLoading ? (
                                <span className={classes.loadingText}>
                                    <span className={classes.spinner}></span>
                                    Saving...
                                </span>
                            ) : (
                                modalMode === "edit" ? "Update Assignment" : "Close"
                            )}
                        </button>
                    </div>
                </div>
            )}

            {/* Create Modal */}
            {showCreateModal && (
                <div className={classes.overlay}>
                    <div className={classes.modal}>
                        <div className={classes.header}>
                            <div className={classes.title}>
                                <User className={classes.icon} />
                                <h2>New Asset Assignment</h2>
                            </div>
                            <button className={classes.closeBtn} onClick={onClose}>
                                <X size={18} />
                            </button>
                        </div>

                        <form onSubmit={handleCreateSubmit}>
                            <div className={classes.formGrid}>
                                <div className={classes.formGroup}>
                                    <label>Select Asset *</label>
                                    <div className={classes.searchSelectWrapper} ref={assetRef}>
                                        <div className={classes.searchInputContainer}>
                                            <input
                                                type="text"
                                                className={classes.searchSelectInput}
                                                placeholder="Search and select asset..."
                                                value={showDropdowns.asset ? searchTerms.asset : getSelectedName('asset')}
                                                onChange={(e) => handleSearchChange('asset', e)}
                                                onClick={() => setShowDropdowns(prev => ({ ...prev, asset: true }))}
                                                onFocus={() => setShowDropdowns(prev => ({ ...prev, asset: true }))}
                                                required
                                            />
                                        </div>

                                        {showDropdowns.asset && (
                                            <div className={classes.searchDropdown}>
                                                <div className={classes.dropdownList}>
                                                    {createLoading.assets ? (
                                                        <div className={classes.dropdownItem}>Loading assets...</div>
                                                    ) : filterItems('asset').length === 0 ? (
                                                        <div className={classes.dropdownItem}>No assets available for assignment</div>
                                                    ) : (
                                                        filterItems('asset').map((item) => (
                                                            <div
                                                                key={item.id}
                                                                className={`${classes.dropdownItem} ${createFormData.asset_id === item.id ? classes.selectedItem : ''}`}
                                                                onClick={() => handleSelect('asset', item)}
                                                            >
                                                                {item.asset_name} ({item.asset_code})
                                                                {item.status && <span className={classes.assetStatus}> - {item.status}</span>}
                                                            </div>
                                                        ))
                                                    )}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                    <small style={{ color: '#666', fontSize: '11px', marginTop: '4px', display: 'block' }}>
                                        Only available assets are shown
                                    </small>
                                </div>

                                <div className={classes.formGroup}>
                                    <label>Select Employee *</label>
                                    <div className={classes.searchSelectWrapper} ref={employeeRef}>
                                        <div className={classes.searchInputContainer}>
                                            <input
                                                type="text"
                                                className={classes.searchSelectInput}
                                                placeholder="Search and select employee..."
                                                value={showDropdowns.employee ? searchTerms.employee : getSelectedName('employee')}
                                                onChange={(e) => handleSearchChange('employee', e)}
                                                onClick={() => setShowDropdowns(prev => ({ ...prev, employee: true }))}
                                                onFocus={() => setShowDropdowns(prev => ({ ...prev, employee: true }))}
                                                required
                                            />
                                        </div>

                                        {showDropdowns.employee && (
                                            <div className={classes.searchDropdown}>
                                                <div className={classes.dropdownList}>
                                                    {createLoading.employees ? (
                                                        <div className={classes.dropdownItem}>Loading employees...</div>
                                                    ) : filterItems('employee').length === 0 ? (
                                                        <div className={classes.dropdownItem}>No employees found</div>
                                                    ) : (
                                                        filterItems('employee').map((item) => (
                                                            <div
                                                                key={item.id}
                                                                className={`${classes.dropdownItem} ${createFormData.employee_id === item.id ? classes.selectedItem : ''}`}
                                                                onClick={() => handleSelect('employee', item)}
                                                            >
                                                                {item.name} {item.employee_code && `(${item.employee_code})`}
                                                            </div>
                                                        ))
                                                    )}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>

                                <div className={classes.formGroup}>
                                    <label>Assigned Date *</label>
                                    <input
                                        type="date"
                                        name="assigned_date"
                                        value={createFormData.assigned_date}
                                        onChange={handleCreateChange}
                                        required
                                    />
                                </div>

                                <div className={classes.formGroup}>
                                    <label>Returned Date (Optional)</label>
                                    <input
                                        type="date"
                                        name="returned_date"
                                        value={createFormData.returned_date}
                                        onChange={handleCreateChange}
                                        min={createFormData.assigned_date}
                                    />
                                </div>

                                <div className={classes.formGroupFull}>
                                    <label>Condition Notes (Optional)</label>
                                    <textarea
                                        name="condition_notes"
                                        placeholder="Enter any notes about the asset condition, remarks, etc."
                                        value={createFormData.condition_notes}
                                        onChange={handleCreateChange}
                                        rows="3"
                                    />
                                </div>
                            </div>

                            <button 
                                type="submit" 
                                className={classes.saveBtn} 
                                disabled={submitting}
                            >
                                {submitting ? "Creating..." : "Create Assignment"}
                            </button>
                        </form>
                    </div>
                </div>
            )}

            <Footer />
        </div>
    );
};

export default AssetAssignment;